const formatWrongMarkdownURL = (markdown = '') => {
    const regex = /<https?:\/\/[^\s<>]+>/g;

    const replacedText = markdown.replace(regex, (match) => match.slice(1, -1));

    return replacedText;
};

export default formatWrongMarkdownURL;
